import { RouteComponentProps } from "../../../../models/RouteComponent";
import { CardActions, CardOverflow, Typography } from "@mui/joy";
import { Button } from "primereact/button";
import React, { useEffect } from "react";
import { LegislationRecord, legislationsArray } from "../../../../models/DSF/Legislation";
import useApiService from "../../../../hooks/useApiService";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import { OpenNewWindow } from "../../../../assets/icons";

function OSHActAndLegislations(props: RouteComponentProps) {
  const { session } = props;
  const { data, error, loading } = useApiService<LegislationRecord[]>({
    method: "GET",
    url: "legislations",
    apiName: "open",
    params: {
      clientId: session.client_id,
      siteId: session.site_id,
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loading);
  }, [loading]);

  const displayLink = (data: legislationsArray) => {
    if (!data.link) return "—";
    return (
      <>
        <Link to={data.link} rel={"noopener noreferrer"} target={"_blank"} className={"link"}>
          {data.title}{" "}
          <span>
            <OpenNewWindow width={16} height={16} />
          </span>
        </Link>
      </>
    );
  };

  return (
    <>
      <Typography level="h2" component="h1">
        OSH Act and legislations
      </Typography>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15, marginBottom: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Download PDF"
            className="p-button-outlined"
            size="small"
            disabled={true}
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => {}}
          />
        </CardActions>
      </CardOverflow>
      {error && (
        <div className={"error-wrapper"}>
          <h2>Error fetching OSH Act and Legislation data</h2>
        </div>
      )}
      {data?.length === 0 && (
        <div>
          <p>No data found</p>
        </div>
      )}
      <Accordion multiple activeIndex={[0]}>
        {data?.map((item, index) => {
          return (
            <AccordionTab header={item.group} key-={index}>
              <DataTable value={item.legislations}>
                <Column field={"title"} header={"Title"} style={{ width: "20%" }} />
                <Column field={"description"} header={"Description"} style={{ width: "60%" }} />
                <Column
                  field={"link"}
                  header={"Link"}
                  body={displayLink}
                  style={{ width: "20%" }}
                />
              </DataTable>
            </AccordionTab>
          );
        })}
      </Accordion>
    </>
  );
}

export default OSHActAndLegislations;
